import React from 'react';
import { Button } from 'components/ui/button';

const HelpButton = ({ onClick }) => {
  return (
    <Button
      onClick={onClick}
      size="icon"
      className="fixed bottom-6 right-6 z-50 rounded-full h-14 w-14 shadow-lg bg-hajj-primary text-white hover:bg-hajj-primary/50"
    >
      <span className="text-2xl">?</span>
    </Button>
  );
};

export default HelpButton;
